import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from "react-oidc-context";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { store } from './app/store';


const cognitoAuthConfig = {
  authority: process.env.REACT_APP_COGNITO_AUTHORITY,
  client_id: process.env.REACT_APP_COGNITO_CLIENT_ID,
  redirect_uri: process.env.REACT_APP_COGNITO_REDIRECT_URL,
  response_type: "code",
  scope: "email openid",
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
    <HelmetProvider>
      <Helmet>
      <title>PortPlay</title>
      <meta name="description" content="PortPlay table-top gaming event in Melbourne" />
      <meta name="viewport" content="initial-scale=1, width=device-width" />
      </Helmet>

      <AuthProvider {...cognitoAuthConfig}>
        <App />
      </AuthProvider>
    </HelmetProvider>
    </Provider>

  </React.StrictMode>
);

